<template>
  <div
    ref="containerElement"
    :class="{
      [ns.e('only-show-container')]: isOnlyShowContainer,
      'full-screen': isFullScreen,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useNamespace } from '@lit-element/hooks'
const isOnlyShowContainer = ref(false)
const isFullScreen = ref(false)
const containerElement = ref<HTMLElement | null>(null)
defineOptions({
  name: 'LtFullScreen',
})

const ns = useNamespace('fullScreen')
const toggleMode = (mode: 'onlyShowContainer' | 'fullScreen') => {
  if (mode === 'onlyShowContainer') {
    console.log('onlyShowContainer')
    if (isFullScreen.value) {
      document.exitFullscreen().catch((err) => {
        console.error(err)
      })
      isFullScreen.value = false
    }
    isOnlyShowContainer.value = !isOnlyShowContainer.value
  } else if (mode === 'fullScreen') {
    if (isFullScreen.value) {
      document.exitFullscreen().catch((err) => {
        console.error(err)
      })
      isFullScreen.value = false
    } else {
      if (containerElement.value) {
        containerElement.value.requestFullscreen().catch((err) => {
          console.error(err)
        })
        isFullScreen.value = true
        isOnlyShowContainer.value = false // 确保在全屏模式下，isOnlyShowContainer 为 false
      }
    }
  }
}
defineExpose({
  toggleMode,
  containerElement,
  isFullScreen,
  isOnlyShowContainer,
})
</script>
